import { render, staticRenderFns } from "./PropertyDeleted.vue?vue&type=template&id=798efcc8"
import script from "./PropertyDeleted.vue?vue&type=script&lang=js"
export * from "./PropertyDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports